import { render } from "./footer-branches-list.vue?vue&type=template&id=bfd99ef6"
import script from "./footer-branches-list.vue?vue&type=script&lang=js"
export * from "./footer-branches-list.vue?vue&type=script&lang=js"

import "./footer-branches-list.vue?vue&type=style&index=0&id=bfd99ef6&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__